import * as S from "../ConvenienceTest.style";
import { useContext, useEffect, useState } from "react";
import Moment from "moment";
import UserIdentitiesService, {
  AccessRequestDto,
  UserIdentityType,
} from "../../../services/UserIdentitiesService";
import SavingsPlans, {
  SavingsPlanType,
} from "../../../services/SavingsPlanService";
import Auth from "../../../Auth/Auth";
import { useHistory, useParams } from "react-router-dom";
import { DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import scrollToTop from "../../../utils/scrollToTop";
import React from "react";
import SavingsPlanService from "../../../services/SavingsPlanService";
import DocumentTitle from "react-document-title";
import { ThemeContext } from "@fluentui/react-theme-provider";
import CustomIcon from "../../icons/CustomIcon";
import { ModalWithCancel } from "../../Modals/ModalWithCancel";
import ModalRequestAuthorization from "../ModalRequestAuthorization/ModalRequestAuthorization";
import { UserIndentityStatusEnum } from "../../types/UserIdentity.Status";
import AuthorizationIcon from "./AuthorizationIcon";
import StatusPill, { getStatus } from "../../StatusPill/StatusPill";
import { useSelector } from "react-redux";

const ConvenienceTestAccountHolder = () => {
  const history = useHistory();
  const theme = useContext(ThemeContext);
  const [error, setError] = useState({ status: false, message: "" });
  const [size, setSize] = useState(window.innerWidth);
  const [savingsPlan, setSavingsPlan] = useState<SavingsPlanType>();
  const [userIdentities, setUserIdentities] = useState<UserIdentityType[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const user = Auth.getUserProfile();
  const { savingsPlanId } = useParams<any>();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [deleteUserName, setDeleteUserName] = React.useState<string>("");
  const userIdentitiesAccessRequestRedux = useSelector(
    (state: any) => state.auth.userIdentityAccessRequest.data
  );

  // modal de autorización
  const [showRequestAuthorizationModal, setShowRequestAuthorizationModal] =
    useState<boolean>(false);
  const [userIdentitiesAccessRequest, setUserIdentitiesAccessRequest] =
    useState<AccessRequestDto[]>([]);
  const [selectedUserIdentity, setSelectedUserIdentity] =
    useState<UserIdentityType>();

  // modal de eliminación de acceso a intervinientes
  const [showDeleteAccessRequestModal, setShowDeleteAccessRequestModal] =
    useState<boolean>(false);
  const [deleteAccessRequestId, setDeleteAccessRequestId] = useState<
    number | null
  >(null);
  const [accessRequestIdentityFullName, setAccessRequestIdentityFullName] =
    useState<string>("");
  // carga de datos
  const [isLoadingAccessRequests, setIsLoadingAccessRequests] =
    useState<boolean>(false);

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => setSize(window.innerWidth));
  }, []);

  useEffect(() => {
    SavingsPlans.getSavingsPlan(savingsPlanId).then(
      (data: SavingsPlanType) => {
        setSavingsPlan(data);
      },
      (error) => {
        setError(error);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // #autorizaciones
  useEffect(() => {
    if (showRequestAuthorizationModal && selectedUserIdentity) {
      if (userIdentitiesAccessRequestRedux.length > 0) {
        const matchedRequest = userIdentitiesAccessRequestRedux.find(
          (accessRequest: AccessRequestDto) =>
            accessRequest.targetUserIdentity?.id === selectedUserIdentity.id
        );
        if (matchedRequest) {
          setUserIdentitiesAccessRequest([matchedRequest]);
        } else {
          setUserIdentitiesAccessRequest([]);
        }
      } else {
        setUserIdentitiesAccessRequest([]);
      }
    }
  }, [
    showRequestAuthorizationModal,
    selectedUserIdentity,
    userIdentitiesAccessRequestRedux,
  ]);

  // obtener los intervinientes + intervinientes por autorización
  const fetchData = async () => {
    try {
      setIsLoaded(false);

      // Paso 1: Obtener los UserIdentities
      const baseUserIdentities =
        await UserIdentitiesService.getIdentitiesByUserId(user.id);

      // Paso 2: Obtener AccessRequests
      const accessRequestResponse =
        await UserIdentitiesService.getAllAccessRequestsByUserId(user.id);

      const accessIdentityExtras: Record<
        number,
        Partial<UserIdentityType>
      > = {};
      const additionalIdentities: UserIdentityType[] = [];

      if (
        accessRequestResponse.status === 200 &&
        accessRequestResponse.count > 0
      ) {
        setUserIdentitiesAccessRequest(accessRequestResponse.data);

        accessRequestResponse.data.forEach(
          (accessRequest: AccessRequestDto) => {
            const target = accessRequest.targetUserIdentity;
            const isRequester = user.id === accessRequest.requestingUserId;

            if (target?.id) {
              if (isRequester) {
                const alreadyInBase = baseUserIdentities.some(
                  (ui) => ui.id === target.id
                );
                const alreadyAdded = additionalIdentities.some(
                  (ai) => ai.id === target.id
                );

                if (!alreadyInBase && !alreadyAdded) {
                  additionalIdentities.push(target);
                }
              }

              accessIdentityExtras[target.id] = {
                fromAccessRequest: true,
                showAuthorizationIcon: !isRequester,
                showPendingAuthorizationButton: isRequester,
                authorizationStatus: accessRequest.status,
                accessRequestId: accessRequest.id,
              };
            }
          }
        );
      }

      // Combinar lista original + adicionales
      const mergedIdentities = [
        ...baseUserIdentities,
        ...additionalIdentities,
      ].map((identity) => {
        const extra = accessIdentityExtras[identity.id!];
        return {
          ...identity,
          ...extra,
        };
      });
      setUserIdentities(mergedIdentities);
    } catch (error: any) {
      setError(error);
    } finally {
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fullName = (identity: UserIdentityType) => {
    var fullName = "";
    if (identity.firstName !== undefined && identity.firstName !== "") {
      fullName = identity.firstName;
    }
    if (identity.lastName !== undefined && identity.lastName !== "") {
      fullName += " " + identity.lastName;
    }
    if (identity.secondLastName !== null && identity.secondLastName !== "") {
      fullName += " " + identity.secondLastName;
    }
    return fullName;
  };

  const handleAuthorizationIconClick = (userIdentity: UserIdentityType) => {
    setShowRequestAuthorizationModal(true);
    setSelectedUserIdentity(userIdentity);
  };

  const redirectToMap = () => {
    history.push("/configurationMap", {
      savingPlanId: savingsPlan?.id,
      savingPlanName: savingsPlan?.name,
    });
  };

  // confirmación de borrado de intervinientes
  const confirmDeleteAccountHolder = (userIdentity: UserIdentityType) => {
    setDeleteId(userIdentity?.id!);
    setDeleteUserName(
      `${userIdentity.firstName} ${userIdentity.lastName} ${userIdentity.secondLastName}`
    );
    setShowDeleteModal(true);
  };

  // confirmación de borrado de acceso a intervinientes
  const confirmDeleteFromAccessRequest = (
    userIdentity: UserIdentityType,
    accessRequestId: number
  ) => {
    setDeleteAccessRequestId(accessRequestId);
    const fullUserIdentityName = fullName(userIdentity);
    setAccessRequestIdentityFullName(fullUserIdentityName.toUpperCase());
    setShowDeleteAccessRequestModal(true);
  };

  // borrado de intervinientes
  const deleteAccountHolder = (userIdentityId: number | null) => {
    if (userIdentityId !== null) {
      UserIdentitiesService.deleteUserIdentity(userIdentityId).then(
        () => {
          UserIdentitiesService.getIdentitiesByUserId(user.id).then(
            (userIdentities: UserIdentityType[]) =>
              setUserIdentities(userIdentities),
            (error) => setError(error)
          );
        },
        (error: any) => setError(error)
      );
    }
  };

  // borrado de acceso en la tabla UserIdentityAccessRequest
  const deleteAccessRequestById = (accessRequestId: number) => {
    if (accessRequestId !== null) {
      setUserIdentities([]);
      setIsLoaded(false);
      try {
        UserIdentitiesService.deleteAccessRequestById(accessRequestId).then(
          (response: any) => {
            if (response.status !== 200) {
              // TODO-hector: ACCESS-REQUEST :: mostrar mensajes de error, no hay nada para mostrar esos errores
              setError({ message: response.message, status: true });
            }
            fetchData();
          }
        );
      } catch (error: any) {
        setError({ message: error.message, status: true });
      }
    }
  };

  const continueToNextStep = () => {
    var nextStep = "2.3";
    if (savingsPlan !== undefined && [0, 1].includes(savingsPlan.type)) {
      nextStep = "2.2";
    }
    SavingsPlanService.patchSavingsPlan(savingsPlanId, {
      configurationMapStep: nextStep,
    }).then(
      () => {
        redirectToMap();
      },
      (error: any) => {
        setError(error);
      }
    );
  };

  return (
    <DocumentTitle
      title={`IronIA - Intervinientes ${
        savingsPlan?.name !== undefined ? "- " + savingsPlan.name : ""
      }`}
    >
      <React.Fragment>
        <S.HelperStyle />
        <S.Cont theme={theme}>
          <S.MainCont className="account-holder-data--main-cont">
            <S.Title>
              <h1>Interviniente</h1>
              <h2>
                Aquí puedes gestionar los distintos tipos de intervinientes de
                tus planes de cartera.
              </h2>
            </S.Title>
            <S.BarCont>
              <S.BgBar />
              <S.ProsBar />
            </S.BarCont>
            {userIdentities !== undefined && (
              <S.TabletCont theme={theme}>
                {size > 899 ? (
                  <S.Table>
                    <tbody>
                      <tr>
                        <th>Nombre y apellidos</th>
                        <th>Correo electrónico</th>
                        <th className="tight">Menor de edad</th>
                        <th className="tight">Conocer a nuestro cliente</th>
                        <th className="tight">Estado autorización</th>
                        <th className="tight"></th>
                      </tr>
                      {userIdentities.length > 0 &&
                        userIdentities.map(
                          (userIdentity: UserIdentityType, index: number) => {
                            var currentDate = Moment();
                            var birthdayDate = Moment(userIdentity.birthday);
                            var isMinor =
                              currentDate.diff(birthdayDate, "years") < 18;
                            return (
                              <tr key={"index" + index}>
                                <td>
                                  {userIdentity.firstName
                                    ? fullName(userIdentity)
                                    : user.fullName}
                                </td>
                                <td>
                                  {userIdentity.email
                                    ? userIdentity.email
                                    : user.email}
                                </td>
                                <td className="text-center">
                                  {isMinor ? "Sí" : "No"}
                                </td>
                                <td className="text-center">
                                  {userIdentity.status !== undefined &&
                                    userIdentity.status ===
                                      UserIndentityStatusEnum.New && (
                                      <span>No</span>
                                    )}
                                  {userIdentity.status !== undefined &&
                                    [
                                      "PENDING",
                                      "ACTIVE",
                                      "OUTDATED",
                                      "CANCELLED",
                                    ].includes(userIdentity.status) && (
                                      <span>Sí</span>
                                    )}
                                </td>
                                <td>
                                  {userIdentity.fromAccessRequest && (
                                    <>
                                      {userIdentity.showPendingAuthorizationButton && (
                                        <div className="status">
                                          <StatusPill
                                            status={getStatus(
                                              userIdentity.authorizationStatus!
                                            )}
                                            type="small"
                                          />
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {!userIdentity.fromAccessRequest && (
                                    <div className="status">
                                      <span>-</span>
                                    </div>
                                  )}
                                </td>
                                <td className="actions">
                                  {/* Caso 1: Intervinientes normales */}
                                  {!userIdentity.fromAccessRequest &&
                                    (() => {
                                      const showDelete =
                                        userIdentity.main === false &&
                                        userIdentity.fnmContractsUserIdentities
                                          ?.length === 0;
                                      return (
                                        <>
                                          <CustomIcon
                                            iconName="Edit"
                                            size="17"
                                            color="#CC214F"
                                            paddingTop="10%"
                                            onClick={() =>
                                              history.push(
                                                "/accountHolderData/" +
                                                  savingsPlanId +
                                                  "/" +
                                                  userIdentity.id +
                                                  "/edit"
                                              )
                                            }
                                          />
                                          {showDelete && (
                                            <CustomIcon
                                              iconName="Delete"
                                              size="17"
                                              color="#CC214F"
                                              paddingTop="10%"
                                              onClick={() =>
                                                confirmDeleteAccountHolder(
                                                  userIdentity
                                                )
                                              }
                                            />
                                          )}

                                          {/* Espaciado condicional */}
                                          <div
                                            style={{
                                              width: showDelete
                                                ? "17px"
                                                : "68px",
                                            }}
                                          />
                                        </>
                                      );
                                    })()}

                                  {/* Caso 2: Intervinientes desde solicitud de acceso */}
                                  {userIdentity.fromAccessRequest && (
                                    <>
                                      {/* Subcaso A: usuario receptor de la solicitud */}
                                      {userIdentity.showAuthorizationIcon && (
                                        <>
                                          <CustomIcon
                                            iconName="Edit"
                                            size="17"
                                            color="#CC214F"
                                            paddingTop="10%"
                                            onClick={() =>
                                              history.push(
                                                "/accountHolderData/" +
                                                  savingsPlanId +
                                                  "/" +
                                                  userIdentity.id +
                                                  "/edit"
                                              )
                                            }
                                          />
                                          {userIdentity.main === false &&
                                          userIdentity
                                            .fnmContractsUserIdentities
                                            ?.length === 0 ? (
                                            <CustomIcon
                                              iconName="Delete"
                                              size="17"
                                              color="#CC214F"
                                              paddingTop="10%"
                                              onClick={() =>
                                                confirmDeleteAccountHolder(
                                                  userIdentity
                                                )
                                              }
                                            />
                                          ) : (
                                            <div style={{ width: "17px" }} />
                                          )}
                                          <AuthorizationIcon
                                            onClick={() =>
                                              handleAuthorizationIconClick(
                                                userIdentity
                                              )
                                            }
                                          />
                                        </>
                                      )}

                                      {/* Subcaso B: usuario solicitante (solo ve el texto de estado) */}
                                      {userIdentity.showPendingAuthorizationButton && (
                                        <>
                                          {getStatus(
                                            userIdentity.authorizationStatus!
                                          ) === "Rechazada" && (
                                            <>
                                              <div style={{ width: "17px" }} />
                                              <CustomIcon
                                                iconName="Delete"
                                                size="17"
                                                color="#CC214F"
                                                paddingBottom="3%"
                                                onClick={() =>
                                                  confirmDeleteFromAccessRequest(
                                                    userIdentity,
                                                    userIdentity.accessRequestId!
                                                  )
                                                }
                                              />
                                            </>
                                          )}
                                          {getStatus(
                                            userIdentity.authorizationStatus!
                                          ) === "Aceptada" && (
                                            <>
                                              <CustomIcon
                                                iconName="RedEye"
                                                size="17"
                                                color="#CC214F"
                                                paddingTop="10%"
                                                onClick={() =>
                                                  history.push(
                                                    "/accountHolderData/" +
                                                      savingsPlanId +
                                                      "/" +
                                                      userIdentity.id +
                                                      "/view"
                                                  )
                                                }
                                              />
                                              <div style={{ width: "17px" }} />{" "}
                                              {/* Ocupa el espacio del icono Delete para alinear */}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </S.Table>
                ) : (
                  <React.Fragment>
                    {userIdentities.length > 0 && (
                      <S.Table>
                        <tbody></tbody>
                        {userIdentities.forEach(
                          (userIdentity: UserIdentityType, index: number) => {
                            var currentDate = Moment();
                            var birthdayDate = Moment(userIdentity.birthday);
                            var isMinor =
                              currentDate.diff(birthdayDate, "years") < 18;
                            return (
                              <tbody key={"index" + index}>
                                <tr>
                                  <th>Nombre y apellidos</th>
                                  <td>
                                    {userIdentity.firstName
                                      ? fullName(userIdentity)
                                      : user.fullName}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Correo electrónico</th>
                                  <td>
                                    {userIdentity.email
                                      ? userIdentity.email
                                      : user.email}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="tight">Menor de edad</th>
                                  <td className="text-center">
                                    {isMinor ? "Sí" : "No"}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="tight">
                                    Conocer a nuestro cliente
                                  </th>
                                  <td className="text-center">
                                    {userIdentity.status !== undefined &&
                                      userIdentity.status ===
                                        UserIndentityStatusEnum.New && (
                                        <span>No</span>
                                      )}
                                    {userIdentity.status !== undefined &&
                                      [
                                        "PENDING",
                                        "ACTIVE",
                                        "OUTDATED",
                                        "CANCELLED",
                                      ].includes(userIdentity.status) && (
                                        <span>Sí</span>
                                      )}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="tight"></th>
                                  <td>
                                    <DefaultButton
                                      className="button mini-primary-button"
                                      onClick={() =>
                                        history.push(
                                          "/accountHolderData/" +
                                            savingsPlanId +
                                            "/" +
                                            userIdentity.id
                                        )
                                      }
                                    >
                                      Editar
                                    </DefaultButton>
                                  </td>
                                </tr>
                              </tbody>
                            );
                          }
                        )}
                      </S.Table>
                    )}
                  </React.Fragment>
                )}
                {!isLoaded && (
                  <div className="ms-Grid-row">
                    <Spinner size={SpinnerSize.large} />
                  </div>
                )}
                <div className="ms-Grid-row">
                  {userIdentities.length === 1 &&
                    userIdentities[0]?.status ===
                      UserIndentityStatusEnum.New && (
                      <div className="ms-Grid-col mt20">
                        <DefaultButton
                          className="button tiny-secondary-button"
                          onClick={() =>
                            history.push(
                              "/accountHolderData/" +
                                savingsPlanId +
                                "/" +
                                userIdentities[0].id
                            )
                          }
                        >
                          Completar datos
                        </DefaultButton>
                      </div>
                    )}
                  {(userIdentities.length > 1 ||
                    (userIdentities.length === 1 &&
                      userIdentities[0]?.status !==
                        UserIndentityStatusEnum.New)) && (
                    <div className="ms-Grid-col mt20 addIntervinientesButtonsContainer">
                      <div>
                        <DefaultButton
                          className="button tiny-secondary-button"
                          onClick={() =>
                            history.push("/accountHolderData/" + savingsPlanId)
                          }
                        >
                          Añadir interviniente
                        </DefaultButton>
                      </div>
                      <div className="intervinientesEspecialesContainer">
                        <p>Añadir intervinientes especiales:</p>
                        <DefaultButton
                          className="button tiny-secondary-button"
                          onClick={() =>
                            history.push("/accountHolderData/" + savingsPlanId)
                          }
                        >
                          Añadir Menor o Dependiente
                        </DefaultButton>
                        <DefaultButton
                          className="button tiny-secondary-button"
                          onClick={() =>
                            history.push(
                              "/accountHolderCompanyData/" + savingsPlanId
                            )
                          }
                          disabled={true}
                        >
                          Añadir Empresa
                        </DefaultButton>
                      </div>
                    </div>
                  )}
                </div>
              </S.TabletCont>
            )}
            {(userIdentities.length > 1 ||
              (userIdentities.length === 1 &&
                userIdentities[0]?.status !== UserIndentityStatusEnum.New)) &&
              savingsPlan?.configurationMapStep === "2.1" && (
                <S.BtnCont>
                  <DefaultButton
                    onClick={() => continueToNextStep()}
                    className="button tiny-secondary-button"
                    disabled={!isLoaded}
                  >
                    Pasar al siguiente paso
                  </DefaultButton>
                </S.BtnCont>
              )}
            {savingsPlan?.configurationMapStep !== "2.1" && (
              <S.BtnCont>
                <DefaultButton
                  onClick={() => redirectToMap()}
                  className="button tiny-secondary-button"
                  disabled={!isLoaded}
                >
                  Volver al mapa
                </DefaultButton>
              </S.BtnCont>
            )}
          </S.MainCont>
        </S.Cont>

        <ModalWithCancel
          showModal={showDeleteModal}
          setShowModal={setShowDeleteModal}
          title="Confirmación de eliminación"
          body={`¿Estás seguro de que deseas eliminar al interviniente ${deleteUserName}?`}
          btnSubmitText="Eliminar"
          onSubmit={() => deleteAccountHolder(deleteId!)}
        />

        <ModalWithCancel
          showModal={showDeleteAccessRequestModal}
          setShowModal={setShowDeleteAccessRequestModal}
          title="Confirmación de eliminación de acceso"
          body={`¿Estás seguro de que deseas eliminar el registro de acceso del interviniente: ${accessRequestIdentityFullName}?`}
          btnSubmitText="Eliminar"
          onSubmit={() => deleteAccessRequestById(deleteAccessRequestId!)}
        />

        {showRequestAuthorizationModal && (
          <ModalRequestAuthorization
            userId={user.id}
            isLoading={isLoadingAccessRequests}
            showModal={showRequestAuthorizationModal}
            userIdentitiesAccessRequest={userIdentitiesAccessRequest}
            selectedUserIdentity={selectedUserIdentity!}
            handleSubmit={(closeModal, updatedAccessRequest) => {
              if (closeModal) {
                setShowRequestAuthorizationModal(false);
              }
              if (updatedAccessRequest) {
                setUserIdentitiesAccessRequest((prev) =>
                  prev.map((req) =>
                    req.id === updatedAccessRequest.id
                      ? updatedAccessRequest
                      : req
                  )
                );
                console.log("Firma exitosa y pill actualizada");
              }
            }}
          ></ModalRequestAuthorization>
        )}
      </React.Fragment>
    </DocumentTitle>
  );
};

export default ConvenienceTestAccountHolder;
